var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "word-count-network", class: _vm.wordCountClass },
    [
      _c("span", { staticClass: "network-icon" }, [
        _c("i", { class: _vm.networkIconClass })
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "total-words",
        domProps: { innerHTML: _vm._s(_vm.captionLength) }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "words-divider" }, [_vm._v("/")]),
      _vm._v(" "),
      _c("span", { staticClass: "max-words" }, [
        _vm._v(_vm._s(_vm.network.max_message_length))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }